import { useMemo } from "react";

import { metadataKeyForDocsRoute } from "../../internal/document-metadata/documentMetadataKey";
import { useRouteParams } from "./useRouteParams";

export function useMetadataKeyForCurrRoute() {
	const { documentId } = useRouteParams();

	return useMemo(() => metadataKeyForDocsRoute(documentId), [documentId]);
}
